import {DatePicker, Form, Modal, TimePicker, Row, Col} from "antd";
import {useFormik} from "formik";
import moment from "moment";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import * as Sentry from "@sentry/react";
import {useStore} from "../../../../hooks/useStore";
import locale from "antd/es/date-picker/locale/tr_TR";

const UpdateModal = ({courierName, id, visibility, date, onCancel}) => {
    const {t} = useTranslation();
    const store = useStore();
    const [confirmLoading, setConfirmLoading] = useState();

    const formik = useFormik({
        initialValues: {date},
        validationSchema: yup.object().shape({
            date: yup.string().required(t("validation.required", {ns: "common"}))
        }),
        enableReinitialize: true,
        onSubmit: async values => {
            setConfirmLoading(true);
            try {
                await store.shiftStore.updateDayOff({
                    id,
                    date: values.date
                });
                onCancel(true);
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                setConfirmLoading(false);
            }
        }
    });

    const {values, errors, touched, handleSubmit, setFieldValue} = formik;

    const getDisabledDate = current => {
        let customDate = moment().format("DD.MM.YYYY");
        return current && current < moment(customDate, "DD.MM.YYYY");
    };

    return (
        <Modal
            title={courierName}
            visible={visibility}
            onCancel={() => {
                onCancel(false);
            }}
            onOk={handleSubmit}
            confirmLoading={confirmLoading}
            okText={t("modal.sendButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
        >
            <Form labelCol={{span: 24}} wrapperCol={{span: 24}}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label={t("fields.date", {ns: "common"})}
                            validateStatus={errors.date && touched.date ? "error" : "success"}
                            help={errors.date && touched.date ? errors.date : null}
                        >
                            <DatePicker
                                locale={locale}
                                value={values.date}
                                format={"DD.MM.YYYY"}
                                disabledDate={getDisabledDate}
                                onSelect={date => setFieldValue("date", date)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default UpdateModal;
